(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koovexo-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-kv-variant]')) return;
  const select = event.target;
  const card = select.closest('[data-kv-offer]');
  const option = select.selectedOptions[0];
  if (!card || !option) return;
  card.querySelector('[data-kv-price]').textContent = option.dataset.price;
  card.querySelector('[data-kv-unit]').textContent = option.dataset.unit;
  const image = card.querySelector('.kv-selected-image');
  image.removeAttribute('srcset');
  image.src = option.dataset.image;
  image.alt = option.dataset.alt;
  card.querySelector('button[type="submit"]').disabled = option.dataset.available !== 'true';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
